import React from 'react';
import Breadcrumbs from '../Breadcrumbs/index';
import { ExperienceTitle } from '../ExperienceTitle.component';
import { useIsMobile } from '../ProjectLocation/helpers';
import ProjectSummary from '../projectSummary/index';
import { ProjectLocationContainer } from '../ProjectLocationContainer.component';
import { FlooringSkeleton } from '../FlooringSkeleton.component';

const HomeSkeleton = () => {
  const isMobile = useIsMobile();

  return (
    <div className="container-fluid">
      <main className="gcc-app">
        <div className="app-container">
          <div className="breadcrumb-container">
            <Breadcrumbs isSkeleton />
          </div>
        </div>
        <div>
          <div className="flooring-container">
            <div className="flooring-wrapper">
              <div className="configurator-container">
                <ExperienceTitle />
                <ProjectLocationContainer isSkeleton />
                <FlooringSkeleton />
              </div>
              {!isMobile && <ProjectSummary isSkeleton />}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HomeSkeleton;
